import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { IssuesCloseOutlined } from '@ant-design/icons';
import type { TripRes } from 'api/swagger';
import { useGetCargoTrips } from 'api/trips/use-get-cargo-trips';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { TripSetTaskModal } from '../trip-set-task-modal';

interface ITripSetTaskProps {
  trip: TripRes;
}

const TripSetTaskComponent: React.FC<ITripSetTaskProps> = (props) => {
  const { trip } = props;
  const { data: cargoTrips, isLoading } = useGetCargoTrips(trip.id);

  const { t } = useTranslation();

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  if (!cargoTrips?.length) return;

  return (
    <>
      <Button icon={<IssuesCloseOutlined />} disabled={isLoading} style={{ marginLeft: 'auto' }} onClick={showModal}>
        {t('trip:set_driver_tasks')}
      </Button>
      <TripSetTaskModal trip={trip} isModalVisible={isModalVisible} handleClose={handleClose} />
    </>
  );
};

export const TripSetTask = withRoleGuard(TripSetTaskComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.transport_manager,
  UserRole.customer_manager,
]);
